module.exports = __webpack_public_path__ + "img/4.b62e65b3.png";